export const ru = {
    pageHeader: 'Анкета специалиста: {fullName}',
    saveError: 'Не удалось обновить анкету, попробуйте позже.'
};
